import { MutationTree } from 'vuex'
import { GoogleMapsState, StoreError, GoogleMapOverlay, GoogleMapPosition, GoogleMapMarker, InfoView } from '@/store/modules/google-maps/types'

export const mutations: MutationTree<GoogleMapsState> = {
  SET_GROUND_OVERLAYS (state, groundOverlays: GoogleMapOverlay[]) {
    state.error = { state: false }
    state.groundOverlays = groundOverlays
  },
  SET_OVERLAY_VIEWS (state, overlayViews: GoogleMapOverlay[]) {
    state.error = { state: false }
    state.overlayViews = overlayViews
  },
  SET_POSITION (state, data: { position: GoogleMapPosition, zoom: number }) {
    state.error = { state: false }
    state.position = data.position
    state.zoom = data.zoom
  },
  SET_MARKERS (state, markers: GoogleMapMarker[]) {
    state.error = { state: false }
    state.markers = markers
  },
  SET_INFOVIEW_STATUS (state, payload: { active: boolean, selectedMarker: number }) {
    state.error = { state: false }
    state.infoview.status = payload
  },
  SET_INFOVIEW_DATA (state, payload: any) {
    state.error = { state: false }
    state.infoview = { ...state.infoview, ...payload }
  },
  RESET_INFOVIEW (state, payload: InfoView) {
    state.error = { state: false }
    state.infoview = payload
  },
  GOOGLE_MAPS_ERROR (state, payload: StoreError) {
    state.error = payload
  },
  SET_AUTOCOMPLETE (state, data: { shown: boolean }) {
    state.error = { state: false }
    state.autocomplete = data
  },
  SET_OPEN_DEFAULT_MARKER_OPTION (state, data: boolean) {
    state.error = { state: false }
    state.openDefaultMarkerOption = data
  },
  SET_DEFAULT_MARKER (state, data: string) {
    state.error = { state: false }
    state.defaultMarker = data
  }
}
